let OptimizationConfig = {
    OPTIMIZATION_SET_CONFIG: 'OPTIMIZATION_SET_CONFIG',
    RUNS_LIMIT: 4,
    EXTRA_OPPOSING_SETTINGS: {
        classic: {
            nfl: {
                0: '0 Players vs Defense',
            },
        },
        tiers: {},
        showdown: {},
        'single-game': {},
    },
};

export default OptimizationConfig;
